<template>
  <div class="phone-input-group">
    <input
      ref="p1"
      :id="inputId"
      type="tel"
      inputmode="numeric"
      v-model="part1"
      @input="onInput(1)"
      @keydown="onKeydown($event, 1)"
      placeholder="010"
      maxlength="3"
      :disabled="disabled"
      :required="required"
      class="phone-segment"
    />
    <span class="phone-separator">-</span>
    <input
      ref="p2"
      type="tel"
      inputmode="numeric"
      v-model="part2"
      @input="onInput(2)"
      @keydown="onKeydown($event, 2)"
      placeholder="0000"
      maxlength="4"
      :disabled="disabled"
      :required="required"
      class="phone-segment"
    />
    <span class="phone-separator">-</span>
    <input
      ref="p3"
      type="tel"
      inputmode="numeric"
      v-model="part3"
      @input="onInput(3)"
      @keydown="onKeydown($event, 3)"
      placeholder="0000"
      maxlength="4"
      :disabled="disabled"
      :required="required"
      class="phone-segment"
    />
  </div>
</template>

<script>
export default {
  name: 'PhoneInput',
  props: {
    modelValue: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    inputId: { type: String, default: '' }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      part1: '',
      part2: '',
      part3: ''
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(val) {
        const parts = this.parse(val || '')
        if (parts[0] !== this.part1) this.part1 = parts[0]
        if (parts[1] !== this.part2) this.part2 = parts[1]
        if (parts[2] !== this.part3) this.part3 = parts[2]
      }
    }
  },
  methods: {
    parse(val) {
      if (!val) return ['', '', '']
      if (val.includes('-')) {
        const split = val.split('-')
        return [split[0] || '', split[1] || '', split[2] || '']
      }
      const digits = val.replace(/[^\d]/g, '')
      if (digits.length <= 3) return [digits, '', '']
      if (digits.length <= 7) return [digits.slice(0, 3), digits.slice(3), '']
      if (digits.length === 10) return [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6)]
      return [digits.slice(0, 3), digits.slice(3, 7), digits.slice(7, 11)]
    },
    sanitize() {
      this.part1 = (this.part1 || '').replace(/[^\d]/g, '').slice(0, 3)
      this.part2 = (this.part2 || '').replace(/[^\d]/g, '').slice(0, 4)
      this.part3 = (this.part3 || '').replace(/[^\d]/g, '').slice(0, 4)
    },
    emitCombined() {
      const combined = [this.part1, this.part2, this.part3].filter(p => p !== '').join('-')
      if (combined !== this.modelValue) {
        this.$emit('update:modelValue', combined)
      }
    },
    onInput(idx) {
      this.sanitize()
      this.emitCombined()
      const maxLengths = { 1: 3, 2: 4, 3: 4 }
      const currentLen = idx === 1 ? this.part1.length : idx === 2 ? this.part2.length : this.part3.length
      if (currentLen >= maxLengths[idx] && idx < 3) {
        this.$nextTick(() => {
          const nextRef = this.$refs[`p${idx + 1}`]
          if (nextRef) nextRef.focus()
        })
      }
    },
    onKeydown(e, idx) {
      if (e.key === 'Backspace' && idx > 1) {
        const currentVal = idx === 2 ? this.part2 : this.part3
        if (currentVal === '') {
          const prevRef = this.$refs[`p${idx - 1}`]
          if (prevRef) prevRef.focus()
        }
      }
    }
  }
}
</script>

<style scoped>
.phone-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.phone-segment {
  flex: 1;
  min-width: 0;
  text-align: center;
  font-family: inherit;
}
.phone-separator {
  color: #aaa;
  flex-shrink: 0;
  font-weight: 500;
}
</style>
